import React from "react";
import { Link } from "react-router-dom";
import CatalogImage from "../common/CatalogImage";
import StatusBadge from "../common/StatusBadge";
import { formatCurrency } from "../../lib/catalog";

export default function TransportCard({ item }) {
  return (
    <article className="card h-100 border-0 shadow-sm catalog-card package-card">
      <CatalogImage
        folder="vehicle"
        fileName={item.vehiclePhoto}
        alt={item.vehicleName}
        height="auto"
        className="package-card__image"
      />
      <div className="card-body d-flex flex-column">
        {/* <div className="package-card__top">
          <div className="text-uppercase text-secondary small fw-semibold package-card__code">
            {item.typeName || "Transport"}
          </div>
          <StatusBadge className="flex-shrink-0" value={item.cityName || item.fuel || "Unknown"} />
        </div> */}

        <h5 className="card-title package-card__name" title={item.vehicleName}>
          {item.vehicleName}
        </h5>

        <div className="package-card__meta">
          <div className="package-card__row">
            <span className="package-card__label">Passengers</span>
            <span className="package-card__value">{item.passengers || "Not set"}</span>
          </div>
          <div className="package-card__row">
            <span className="package-card__label">Baggage</span>
            <span className="package-card__value">{item.baggage || "Not set"}</span>
          </div>
          <div className="package-card__row">
            <span className="package-card__label">Fuel</span>
            <span className="package-card__value">{item.fuel || "Not set"}</span>
          </div>
        </div>

        <div className="package-card__footer mt-auto">
          <div className="package-card__prices">
            <div className="package-card__label">Price</div>
            <div className="package-card__net">{formatCurrency(item.amount, "INR")}</div>
          </div>
          <Link to={`/transportation/${item.id}`} className="btn btn-primary btn-sm package-card__book">
            Book
          </Link>
        </div>
      </div>
    </article>
  );
}
